export default __webpack_public_path__ + "static/media/under-construction.d9219ea9.png";